import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import image_croix from "../Pages/image/croix.png";
import TrainingService from '../../Service/TrainingService';

const TrainingPres = ({ training }) => {
    const [editMode, setEditMode] = useState(false);
    const [textAreaValue, setTextAreaValue] = useState('');
    const token = sessionStorage.getItem('token');

    // Convertir le HTML en texte brut au moment de l'édition
    useEffect(() => {
        if (training.presentation) {
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = training.presentation;  // Le texte initial est en HTML
            setTextAreaValue(tempDiv.innerText);  // Convertir le HTML en texte brut pour l'édition
        }
    }, [training.presentation]);

    const handleEditClick = () => {
        setEditMode(true);
    };

    const handleInputChange = (event) => {
        setTextAreaValue(event.target.value);
    };

    const handleSaveClick = async () => {
        // Sauvegarder le texte modifié dans l'objet training
        training.presentation = textAreaValue;  // Le texte modifié reste en texte brut

        try {
            let response;
            if (training.modif) {
                response = await TrainingService.putModifTraining(training);
            } else {
                response = await TrainingService.postModifTraining(training);
            }
            window.location.reload();
            console.log(response);
        } catch (error) {
            console.log("Error: " + error);
        }
        setEditMode(false);
    };

    return (
        <div className="section-content">
            {editMode ? (
                // Mode édition : afficher le texte dans un textarea pour le modifier
                <textarea
                    value={textAreaValue}
                    onChange={handleInputChange}
                    rows={10}
                    style={{ width: '100%' }}
                />
            ) : (
                // Mode affichage : interpréter le texte brut tout en respectant les sauts de ligne
                <div>
                    {/* Utilisation de white-space: pre-wrap pour afficher les sauts de ligne */}
                    <div style={{ whiteSpace: 'pre-wrap', textAlign: 'justify' }}>
                        {textAreaValue}
                    </div>
                </div>
            )}
            {editMode ? (
                <button
                    className="inscription-button modif_button"
                    onClick={handleSaveClick}
                    style={{ right: 0 }}
                >
                    Enregistrer
                </button>
            ) : (
                token === '' && (
                    <button
                        className="inscription-button modif_button"
                        onClick={handleEditClick}
                        style={{ marginLeft: '10px' }}
                    >
                        Modifier
                    </button>
                )
            )}
        </div>
    );
};

export default TrainingPres;